import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "activity-log-panel" }
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "panel-filters" }
const _hoisted_4 = {
  key: 0,
  class: "log-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "log-empty"
}
const _hoisted_6 = {
  key: 2,
  class: "log-list"
}
const _hoisted_7 = { class: "log-body" }
const _hoisted_8 = { class: "log-main" }
const _hoisted_9 = { class: "log-actor" }
const _hoisted_10 = {
  key: 0,
  class: "log-entity"
}
const _hoisted_11 = { class: "log-meta" }
const _hoisted_12 = {
  key: 0,
  class: "log-details"
}
const _hoisted_13 = { class: "log-time" }
const _hoisted_14 = {
  key: 3,
  class: "log-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "panel-title" }, "Log de atividades", -1)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterEntity) = $event)),
          class: "filter-select",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("option", { value: "" }, "Todos", -1),
          _createElementVNode("option", { value: "task" }, "Tarefas", -1),
          _createElementVNode("option", { value: "project" }, "Projetos", -1),
          _createElementVNode("option", { value: "account" }, "Usuários", -1)
        ]))], 544), [
          [_vModelSelect, _ctx.filterEntity]
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("div", { class: "spinner" }, null, -1),
          _createTextVNode(" Carregando… ", -1)
        ]))]))
      : (_ctx.entries.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("svg", {
              width: "40",
              height: "40",
              viewBox: "0 0 40 40",
              fill: "none"
            }, [
              _createElementVNode("rect", {
                x: "6",
                y: "4",
                width: "28",
                height: "32",
                rx: "3",
                stroke: "var(--ink-muted,#888)",
                "stroke-width": "1.8"
              }),
              _createElementVNode("path", {
                d: "M13 14h14M13 20h10M13 26h7",
                stroke: "var(--ink-muted,#888)",
                "stroke-width": "1.8",
                "stroke-linecap": "round"
              })
            ], -1),
            _createElementVNode("p", null, "Nenhuma atividade registrada ainda.", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry) => {
              return (_openBlock(), _createElementBlock("div", {
                key: entry.id,
                class: "log-entry"
              }, [
                _createElementVNode("div", {
                  class: "log-avatar",
                  style: _normalizeStyle({ background: _ctx.avatarColor(entry.actorName) })
                }, _toDisplayString(_ctx.initials(entry.actorName)), 5),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(entry.actorName), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["log-action-chip", 'action-' + _ctx.actionClass(entry.action)])
                    }, _toDisplayString(_ctx.actionLabel(entry.action)), 3),
                    (entry.entityName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(entry.entityName), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (entry.details)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(entry.details), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatTime(entry.createdAt)), 1)
                  ])
                ])
              ]))
            }), 128))
          ])),
    (_ctx.entries.length > 0 && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "load-more-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
          }, "Carregar mais")
        ]))
      : _createCommentVNode("", true)
  ]))
}